var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PSelect',{attrs:{"disabled":_vm.disabled,"items":_vm.trucktypes,"label":_vm.$tk('PTrucktype.StandardTruckType'),"itemValue":"id","itemText":"name"},model:{value:(_vm.stdTruckType),callback:function ($$v) {_vm.stdTruckType=$$v},expression:"stdTruckType"}})
}
var staticRenderFns = []

export { render, staticRenderFns }